import React from 'react';
import SearchBox from './components/SearchBox';
import './app.scss';
import Header from './components/Layout/header';
import DescribeSection from './components/Layout/describeSection';
import Footer from './components/Layout/footer';
import FAQ from './components/Layout/Faq/faq';
import SampleComparison from './components/Layout/Sample/sample';

function App() {
  return (
    <div className="layout">
      <Header />
      <DescribeSection />
      <div className="placebox-container">
        <SearchBox 
          placeholder="Type to Add Place 1"
        />
        <SearchBox 
          placeholder="Type to Add Place 2"
        />
        <SearchBox 
          placeholder="Type to Add Place 3"
        />
        <SearchBox 
          placeholder="Type to Add Place 4"
        />
      </div>
      <FAQ />
      <SampleComparison />
      <Footer />
    </div>
  );
}

export default App;
